import { produce } from "immer";
import ProjectDto from "types/ProjectDto";

export const scope = "ProjectManagement";

const ProjectManagementStore = (set) => ({
  setProject: (project: ProjectDto) => {
    set(
      produce((currentState: ProjectDto) => {
        currentState[scope] = {
          ...currentState[scope],
          ...project,
        };
      }),
      false,
      `[${scope}.setProject](${JSON.stringify(project)})`,
    );
  },
});

export default ProjectManagementStore;
